module.exports = __webpack_public_path__ + "6fd57b4a5a9ff63e9b3f37482e83b2ba.svg";